import { render, staticRenderFns } from "./InputRating.vue?vue&type=template&id=17036f04"
import script from "./InputRating.vue?vue&type=script&lang=js"
export * from "./InputRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports